"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIconWrapper = exports.IconTouchArea = exports.StyledIcon = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyledLayout = require("./StyledLayout");

var _add = _interopRequireDefault(require("../assets/icons/add.svg"));

var _addToGallery_veryDarkGrey = _interopRequireDefault(require("../assets/icons/addToGallery_veryDarkGrey.svg"));

var _addToGallery_primaryBlueHover = _interopRequireDefault(require("../assets/icons/addToGallery_primaryBlueHover.svg"));

var _calendar_veryDarkGrey = _interopRequireDefault(require("../assets/icons/calendar_veryDarkGrey.svg"));

var _camera_veryDarkGrey = _interopRequireDefault(require("../assets/icons/camera_veryDarkGrey.svg"));

var _cameraLens_veryDarkGrey = _interopRequireDefault(require("../assets/icons/cameraLens_veryDarkGrey.svg"));

var _checkmark_veryDarkGrey = _interopRequireDefault(require("../assets/icons/checkmark_veryDarkGrey.svg"));

var _chevronDown = _interopRequireDefault(require("../assets/icons/chevronDown.svg"));

var _chevronUp = _interopRequireDefault(require("../assets/icons/chevronUp.svg"));

var _comment_veryDarkGrey = _interopRequireDefault(require("../assets/icons/comment_veryDarkGrey.svg"));

var _community = _interopRequireDefault(require("../assets/icons/community.svg"));

var _copyright = _interopRequireDefault(require("../assets/icons/copyright.svg"));

var _crown = _interopRequireDefault(require("../assets/icons/crown.svg"));

var _discover = _interopRequireDefault(require("../assets/icons/discover.svg"));

var _edit_veryDarkGrey = _interopRequireDefault(require("../assets/icons/edit_veryDarkGrey.svg"));

var _editorsChoice_veryDarkGrey = _interopRequireDefault(require("../assets/icons/editorsChoice_veryDarkGrey.svg"));

var _exposure = _interopRequireDefault(require("../assets/icons/exposure.svg"));

var _fresh_veryDarkGrey = _interopRequireDefault(require("../assets/icons/fresh_veryDarkGrey.svg"));

var _flag_veryDarkGrey = _interopRequireDefault(require("../assets/icons/flag_veryDarkGrey.svg"));

var _flag_primaryBlueHover = _interopRequireDefault(require("../assets/icons/flag_primaryBlueHover.svg"));

var _homefeed = _interopRequireDefault(require("../assets/icons/homefeed.svg"));

var _popular_veryDarkGrey = _interopRequireDefault(require("../assets/icons/popular_veryDarkGrey.svg"));

var _upcoming_veryDarkGrey = _interopRequireDefault(require("../assets/icons/upcoming_veryDarkGrey.svg"));

var _location_veryDarkGrey = _interopRequireDefault(require("../assets/icons/location_veryDarkGrey.svg"));

var _lockClosed_veryDarkGrey = _interopRequireDefault(require("../assets/icons/lockClosed_veryDarkGrey.svg"));

var _logged_out_user = _interopRequireDefault(require("../assets/icons/logged_out_user.svg"));

var _messenger_veryDarkGrey = _interopRequireDefault(require("../assets/icons/messenger_veryDarkGrey.svg"));

var _notification = _interopRequireDefault(require("../assets/icons/notification.svg"));

var _pig = _interopRequireDefault(require("../assets/icons/pig.svg"));

var _quote = _interopRequireDefault(require("../assets/icons/quote.svg"));

var _search = _interopRequireDefault(require("../assets/icons/search.svg"));

var _settings_veryDarkGrey = _interopRequireDefault(require("../assets/icons/settings_veryDarkGrey.svg"));

var _share_veryDarkGrey = _interopRequireDefault(require("../assets/icons/share_veryDarkGrey.svg"));

var _studio = _interopRequireDefault(require("../assets/icons/studio.svg"));

var _trash_veryDarkGrey = _interopRequireDefault(require("../assets/icons/trash_veryDarkGrey.svg"));

var _trash_primaryBlueHover = _interopRequireDefault(require("../assets/icons/trash_primaryBlueHover.svg"));

var _facebook_veryDarkGrey = _interopRequireDefault(require("../assets/icons/facebook_veryDarkGrey.svg"));

var _twitter_veryDarkGrey = _interopRequireDefault(require("../assets/icons/twitter_veryDarkGrey.svg"));

var _pinterest_veryDarkGrey = _interopRequireDefault(require("../assets/icons/pinterest_veryDarkGrey.svg"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledIcon = _styledComponents["default"].div.withConfig({
  displayName: "StyledIcons__StyledIcon",
  componentId: "sc-1tde1rj-0"
})(["height:16px;min-width:16px;background-repeat:no-repeat;background-size:contain;background-position:center;position:relative;z-index:1;", ";", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], _StyledLayout.spacing, function (props) {
  return props.medium && (0, _styledComponents.css)(["height:24px;min-width:24px;"]);
}, function (props) {
  return props.large && (0, _styledComponents.css)(["height:32px;min-width:32px;"]);
}, function (props) {
  return props.xlarge && (0, _styledComponents.css)(["height:36px;min-width:36px;"]);
}, function (props) {
  return props.xxlarge && (0, _styledComponents.css)(["height:64px;min-width:64px;"]);
}, function (props) {
  return props.link && (0, _styledComponents.css)(["cursor:pointer;"]);
}, function (props) {
  return props.addToGallery && (0, _styledComponents.css)(["background-image:url(", ");", " ", ""], _addToGallery_veryDarkGrey["default"], props.link && (0, _styledComponents.css)(["&:hover{background-image:url(", ");}"], _addToGallery_primaryBlueHover["default"]), props.primaryBlue && (0, _styledComponents.css)(["background-image:url(", ");"], _addToGallery_primaryBlueHover["default"]));
}, function (props) {
  return props.location && (0, _styledComponents.css)(["background-image:url(", ");"], _location_veryDarkGrey["default"]);
}, function (props) {
  return props.calendar && (0, _styledComponents.css)(["background-image:url(", ");"], _calendar_veryDarkGrey["default"]);
}, function (props) {
  return props.camera && (0, _styledComponents.css)(["background-image:url(", ");"], _camera_veryDarkGrey["default"]);
}, function (props) {
  return props.cameraLens && (0, _styledComponents.css)(["background-image:url(", ");"], _cameraLens_veryDarkGrey["default"]);
}, function (props) {
  return props.comment && (0, _styledComponents.css)(["background-image:url(", ");"], _comment_veryDarkGrey["default"]);
}, function (props) {
  return props.community && (0, _styledComponents.css)(["background-image:url(", ");"], _community["default"]);
}, function (props) {
  return props.crown && (0, _styledComponents.css)(["background-image:url(", ");"], _crown["default"]);
}, function (props) {
  return props.pig && (0, _styledComponents.css)(["background-image:url(", ");"], _pig["default"]);
}, function (props) {
  return props.studio && (0, _styledComponents.css)(["background-image:url(", ");"], _studio["default"]);
}, function (props) {
  return props.copyright && (0, _styledComponents.css)(["background-image:url(", ");"], _copyright["default"]);
}, function (props) {
  return props.exposure && (0, _styledComponents.css)(["background-image:url(", ");"], _exposure["default"]);
}, function (props) {
  return props.quote && (0, _styledComponents.css)(["background-image:url(", ");"], _quote["default"]);
}, function (props) {
  return props.chevronDown && (0, _styledComponents.css)(["background-image:url(", ");"], _chevronDown["default"]);
}, function (props) {
  return props.chevronUp && (0, _styledComponents.css)(["background-image:url(", ");"], _chevronUp["default"]);
}, function (props) {
  return props.add && (0, _styledComponents.css)(["background-image:url(", ");"], _add["default"]);
}, function (props) {
  return props.notification && (0, _styledComponents.css)(["background-image:url(", ");"], _notification["default"]);
}, function (props) {
  return props.search && (0, _styledComponents.css)(["background-image:url(", ");"], _search["default"]);
}, function (props) {
  return props.discover && (0, _styledComponents.css)(["background-image:url(", ");"], _discover["default"]);
}, function (props) {
  return props.homefeed && (0, _styledComponents.css)(["background-image:url(", ");"], _homefeed["default"]);
}, function (props) {
  return props.loggedOutUser && (0, _styledComponents.css)(["background-image:url(", ");"], _logged_out_user["default"]);
}, function (props) {
  return props.edit && (0, _styledComponents.css)(["background-image:url(", ");"], _edit_veryDarkGrey["default"]);
}, function (props) {
  return props.flag && (0, _styledComponents.css)(["background-image:url(", ");", ""], _flag_veryDarkGrey["default"], props.link && (0, _styledComponents.css)(["&:hover{background-image:url(", ");}"], _flag_primaryBlueHover["default"]));
}, function (props) {
  return props.link && (0, _styledComponents.css)(["cursor:pointer;"]);
}, function (props) {
  return props.location && (0, _styledComponents.css)(["background-image:url(", ");"], _location_veryDarkGrey["default"]);
}, function (props) {
  return props.messenger && (0, _styledComponents.css)(["background-image:url(", ");"], _messenger_veryDarkGrey["default"]);
}, function (props) {
  return props.settings && (0, _styledComponents.css)(["background-image:url(", ");"], _settings_veryDarkGrey["default"]);
}, function (props) {
  return props.trash && (0, _styledComponents.css)(["background-image:url(", ");", ""], _trash_veryDarkGrey["default"], props.link && (0, _styledComponents.css)(["&:hover{background-image:url(", ");}"], _trash_primaryBlueHover["default"]));
}, function (props) {
  return props.lockClosed && (0, _styledComponents.css)(["background-image:url(", ");"], _lockClosed_veryDarkGrey["default"]);
}, function (props) {
  return props.badge === 'editorsChoice' && (0, _styledComponents.css)(["background-image:url(", ");"], _editorsChoice_veryDarkGrey["default"]);
}, function (props) {
  return props.badge === 'popular' && (0, _styledComponents.css)(["background-image:url(", ");"], _popular_veryDarkGrey["default"]);
}, function (props) {
  return props.badge === 'upcoming' && (0, _styledComponents.css)(["background-image:url(", ");"], _upcoming_veryDarkGrey["default"]);
}, function (props) {
  return props.badge === 'fresh' && (0, _styledComponents.css)(["background-image:url(", ");"], _fresh_veryDarkGrey["default"]);
}, function (props) {
  return props.checkmark && (0, _styledComponents.css)(["background-image:url(", ");"], _checkmark_veryDarkGrey["default"]);
}, function (props) {
  return props.share && (0, _styledComponents.css)(["background-image:url(", ");"], _share_veryDarkGrey["default"]);
}, function (props) {
  return props.facebook && (0, _styledComponents.css)(["background-image:url(", ");"], _facebook_veryDarkGrey["default"]);
}, function (props) {
  return props.twitter && (0, _styledComponents.css)(["background-image:url(", ");"], _twitter_veryDarkGrey["default"]);
}, function (props) {
  return props.pinterest && (0, _styledComponents.css)(["background-image:url(", ");"], _pinterest_veryDarkGrey["default"]);
}, function (props) {
  return props.backgroundPosition && (0, _styledComponents.css)(["background-position:", ";"], props.backgroundPosition);
});

exports.StyledIcon = StyledIcon;

var IconTouchArea = _styledComponents["default"].div.withConfig({
  displayName: "StyledIcons__IconTouchArea",
  componentId: "sc-1tde1rj-1"
})(["height:24px;width:24px;cursor:pointer;background-color:transparent;position:absolute;top:-12.5%;left:-12.5%;&:focus{outline:none;}", " ", " ", ""], function (props) {
  return props.medium && (0, _styledComponents.css)(["height:32px;width:32px;"]);
}, function (props) {
  return props.large && (0, _styledComponents.css)(["height:48px;width:48px;top:-25%;left:-25%;"]);
}, function (props) {
  return props.xlarge && (0, _styledComponents.css)(["height:56px;width:56px;top:-25%;left:-25%;"]);
});

exports.IconTouchArea = IconTouchArea;

var StyledIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "StyledIcons__StyledIconWrapper",
  componentId: "sc-1tde1rj-2"
})(["", ";height:", ";min-width:", ";position:relative;&:focus{outline:none;}.isvg{width:", ";height:", ";}", " ", " ", " svg{width:", ";height:", ";.inline_svg_icon__fill{fill:", ";}", "}", " ", " ", " ", " ", ""], _StyledLayout.spacing, function (props) {
  return props.theme.iconSm;
}, function (props) {
  return props.theme.iconSm;
}, function (props) {
  return props.theme.iconSm;
}, function (props) {
  return props.theme.iconSm;
}, function (props) {
  return props.fill && (0, _styledComponents.css)(["svg g > path{fill:", " !important;}svg > path{fill:", " !important;}"], props.theme[props.fill], props.theme[props.fill]);
}, function (props) {
  return !props.noHover && !props.white && (0, _styledComponents.css)(["&:hover{svg .inline_svg_icon__fill{fill:", ";}}"], props.likeButton && props.theme.heartColorOutlineHover || props.theme.iconColorHover);
}, function (props) {
  return props.link && (0, _styledComponents.css)(["&:hover{cursor:pointer;}"]);
}, function (props) {
  return props.theme.iconSm;
}, function (props) {
  return props.theme.iconSm;
}, function (props) {
  return props.white && props.theme.iconColorWhite || props.mediumGrey && props.theme.mediumGrey || props.primaryBlue && props.theme.primaryBlue || props.theme.iconColorDefault;
}, function (props) {
  return props.disabled && (0, _styledComponents.css)([".inline_svg_icon__fill{fill:", ";}&:hover{.inline_svg_icon__fill{fill:", ";}}"], props.theme.iconColorDisabled, props.theme.iconColorDisabled);
}, function (props) {
  return props.medium && (0, _styledComponents.css)(["height:", ";min-width:", ";svg,.isvg{height:", ";width:", ";}"], props.theme.iconMd, props.theme.iconMd, props.theme.iconMd, props.theme.iconMd);
}, function (props) {
  return props.large && (0, _styledComponents.css)(["height:", ";min-width:", ";svg,.isvg{height:", ";width:", ";}"], props.theme.iconLg, props.theme.iconLg, props.theme.iconLg, props.theme.iconLg);
}, function (props) {
  return props.xlarge && (0, _styledComponents.css)(["height:", ";min-width:", ";svg,.isvg{height:", ";width:", ";}"], props.theme.iconXl, props.theme.iconXl, props.theme.iconXl, props.theme.iconXl);
}, function (props) {
  return props.notificationBadge && (0, _styledComponents.css)(["height:56px;min-width:56px;svg,.isvg{height:56px;width:56px;}"]);
}, function (props) {
  return props.link && (0, _styledComponents.css)(["cursor:pointer;"]);
});

exports.StyledIconWrapper = StyledIconWrapper;